import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=1d1ce4b4&scoped=true&"
import script from "./ranking.vue?vue&type=script&lang=js&"
export * from "./ranking.vue?vue&type=script&lang=js&"
import style0 from "./ranking.vue?vue&type=style&index=0&id=1d1ce4b4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1ce4b4",
  null
  
)

export default component.exports